
import React, { useState, useEffect } from 'react';
import './scmMemberUploadFile.css';
import { useNavigate } from "react-router-dom";
import { authKey, UPLOAD_DCUMENT } from '../../../../common/URLs';

import { loaderService } from "../../../../common/custom-loader/loader-service";
import TrashIcon from '../../../../images/TrashIcon.png';
import { PROD } from '../../../../common/constants';
import { Container, Stack, Typography, Grid, TextField, Button, Card, CardContent } from '@mui/material';
import BackButton from '../../../../common/backButton';
import { allowedFileTypes, FILE_NAME_VALIDATION_ERROR } from '../../../../common/constants';
import { VALIDATION, openTextFieldMaxLength, fileNameValidation, linkMaxLength, approverCommentMaxLength, capitalizeFunction } from '../../../../common/commonValidations';
import BadgeComponent from '../../../../common/badge';
import apiClient from '../../../../axios';

function ScmMemberUploadFile() {

  const navigate = useNavigate()
  const [documentUploadDetails, setDocumentUploadDetails] = useState();
  const [documentsArr, setDocumentsArr] = useState();
  console.log("documentsArr", documentsArr)
  const [selectedFile, setSelectedFile] = useState();
  const [comment, setComment] = useState();
  const [link, setLink] = useState();
  const [fileuploadError, setFileuploadError] = useState('');

  const onSubmit = (e) => {

    if (documentsArr || link) {
      navigate("scmMemberSelectStakeholder", { state: { documentsArr: documentsArr, comment: comment, link: link } });
      setFileuploadError("")
    }
    else {
      setFileuploadError("Please upload the training material or training link to proceed")
    }
  }
  const handleChange = (e) => {
    if(e.target.name === "link") {
      setLink(e.target.value);
    }
    else {
      setComment(VALIDATION.noSpecialCharacterValidation(e.target.value));
    }
  };

  const onDeleteFile = (e, item) => {
    e.preventDefault();
    const rows = [...documentsArr];
    rows.splice(item, 1);
    setDocumentsArr(rows);
  }

  useEffect(() => {
    if (selectedFile) {
      getDocumentUploadDetails();
    }
  }, [selectedFile]);

  useEffect(() => {
    if (documentUploadDetails) {
      let tempARR = documentsArr ? [...documentsArr] : []
      documentUploadDetails?.blobResponse && tempARR.push(documentUploadDetails?.blobResponse);
      setDocumentsArr(tempARR);
    }
  }, [documentUploadDetails]);

  const uploadDocument = (e, type) => {
    if (allowedFileTypes.indexOf(e.target.files[0].type) < 0) {
      return;
  }
    if (e.target.files[0].size >= 5000000) {
      setFileuploadError('The file should be less than 5MB');
      setSelectedFile();
    }
    else if (e.target.files[0].name.split('.').length > 2) {
      setFileuploadError("Double extension file detected");
      setSelectedFile();
    }
    else if(fileNameValidation(e.target.files[0].name)) {
      setFileuploadError(FILE_NAME_VALIDATION_ERROR);
      setSelectedFile();
    }
    else {
      setSelectedFile(e.target.files[0]);
      setFileuploadError('');
    }
  };

  function getDocumentUploadDetails() {
    loaderService.showLoader();
    const formData = new FormData();
    formData.append("file", selectedFile);
    formData.append("fileName", selectedFile.name);
    formData.append("containerName", "resourcefiles");
    apiClient
      .post(
        UPLOAD_DCUMENT,
        formData,
        {
          headers: {
            AuthKey: authKey,
          },
        }
      )
      .then((response) => {
        setDocumentUploadDetails(response.data);
        loaderService.hideLoader();
      })

      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader();
      });
  }

  return (
    <>
      <Container maxWidth="xxl">
        {!PROD && <p className='pageNumberingResc'>RES07</p>}
        <Stack direction="row" alignItems="center" spacing={1} mb={1}>
          <BackButton navigate={navigate} />
          <Typography variant="h5" gutterBottom>
            Upload Training Material
          </Typography>
        </Stack>
        <Card>
          <CardContent>
            <Grid container spacing={1} direction="column">
              <Grid item xs={12} lg={12}>
                <div className='row-flex'>
                  <label className="view-file-link-common">
                    <input
                      style={{ display: "none" }}
                      type="file"
                      accept="image/jpeg, image/jpg, image/png, .pdf"
                      name="photo"
                      onChange={(e) => uploadDocument(e)}
                    />Choose File
                  </label>
                  {documentsArr?.map((item, index) => {
                    return (
                      <div style={{ display: "flex", flexDirection: "row", marginLeft: '1vh' }} className='view-file-name-common'>
                        {item?.fileName}
                        <img src={TrashIcon} style={{ cursor: "pointer", marginLeft: "2vh", height: "3vh" }} alt="TrashIcon" onClick={(e) => onDeleteFile(e, item)} />
                      </div>
                    )
                  })}
                </div>
                <Typography style={{ marginLeft: "3vh" }} variant="subtitle2" fontSize="1.8vh" align="left" color="green">(upload only .png, .jpg, .jpeg, files.File size limit=5MB)</Typography>
                <div className='resource-knowledge-error-message' >{fileuploadError}</div>
              </Grid>
              &nbsp;
              &nbsp;
              <Grid item xs={12} lg={6} ml={2}>
                <TextField
                  fullWidth
                  label="Add Link"
                  name="link"
                  inputProps={{
                    maxLength: openTextFieldMaxLength
                }}
                  multiline
                  rows={4}
                  value={link}
                  onChange={(e) => handleChange(e)}
                />
                <BadgeComponent currentLength={link?.length} maxLength={linkMaxLength} />
              </Grid>
              <Grid item xs={12} lg={6} mt={2} ml={2}>
                <TextField
                  fullWidth
                  label="Add Comment"
                  name="comment"
                  inputProps={{
                    maxLength: openTextFieldMaxLength,
                    // style: { textTransform: "capitalize" }
                }}
                  multiline
                  rows={4}
                  value={comment}
                  onChange={(e) => handleChange(e)}
                />
                <BadgeComponent currentLength={comment?.length} maxLength={approverCommentMaxLength} />
              </Grid>
            </Grid>
            <Grid item xs={12} lg={12} display='flex' justifyContent="flex-end">
              <Button sx={{ minWidth: 100, ml: 2, mt: 19 }} variant="contained" onClick={(e) => onSubmit(e)}>Next</Button>
            </Grid>
          </CardContent>
        </Card>
      </Container>
    </>
  )
}

export default ScmMemberUploadFile;